export default "__VITE_ASSET__v294QL0O__"